import { RouterModule, Routes } from "@angular/router";
import { SafetyComponent } from "./safety.component";
import { NgModule } from "@angular/core";
import { provideState } from "@ngrx/store";
import { safetyReducer } from "./state/safety.reducer";
import { provideEffects } from "@ngrx/effects";
import { SafetyEffects } from "./state/safety.effects";
import { PermissionGuard } from "src/app/shared/guards/permission.guard";
import { PermissionConstants } from "src/app/constants/permissions";

export const safetyRoutes: Routes = [
  {
    path:'',
    component:SafetyComponent,
    providers: [
      provideState('safety', safetyReducer),
      provideEffects([SafetyEffects])
    ],
    children:[
      {
        path:'addevent',
        canActivate: [PermissionGuard],
        data: { requiredPermission: [PermissionConstants.SafetyEventsPermissions.CanAddSafetyEvents] },
        loadComponent: () =>
          import('../Safety/add-safety-event/add-safety-event.component').then(
            (m) => m.AddSafetyEventComponent
          ),
      },
      {
        path:'editevent/:id',
        canActivate: [PermissionGuard],
        data: { requiredPermission: [PermissionConstants.SafetyEventsPermissions.CanEditSafetyEvents, PermissionConstants.SafetyEventsPermissions.CanManageSafetyEvents] },
        loadComponent: () =>
          import('../Safety/add-safety-event/add-safety-event.component').then(
            (m) => m.AddSafetyEventComponent
          ),
      },
      {
        path:'list',
        loadComponent: () =>
          import('./safety-event-list/safety-event-list.component').then(
            (m) => m.SafetyEventListComponent
          ),
      },
      {
        path:'statistics',
        loadComponent: () =>
          import('./safety-statistics-page/safety-statistics-page.component').then(
            (m) => m.SafetyStatisticsPageComponent
          ),
      },
      {path:'',redirectTo:'list',pathMatch:'full'}
    ]
  },
];
@NgModule({
  imports: [RouterModule.forChild(safetyRoutes)],
  exports: [RouterModule]
})
export class SafetyRoutingModule{};
